import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface ICustomerDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ICustomerDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetRetailCustomerDetail: any[];
  GetRetailCustomerDetail_dummy: any[];
  GetRetailCustomerAdress: any[];
  GetRetailCustomerAdress_dummy: any[];
  isComp923475Visible: "visible" | "hidden";
}

export class CustomerDetail_ScreenBase extends React.PureComponent<
  ICustomerDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  customerdetail_989073_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4a8ed839-21c4-4186-8044-00281bcc690a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 967597, PropertyName: "value", Value: "Düşürk Risk" },
        { Id: 635925, PropertyName: "value", Value: "2 Gecikmiş Taksit" },
        { Id: 715780, PropertyName: "value", Value: "Genel Bilgiler" },
        { Id: 671629, PropertyName: "value", Value: "TC Kimlik No:" },
        { Id: 732908, PropertyName: "value", Value: "Kredi Limiti" },
        { Id: 426419, PropertyName: "value", Value: "Bakiye" },
        { Id: 228444, PropertyName: "value", Value: "Kalan Kredi Limiti" },
        { Id: 377828, PropertyName: "value", Value: "Limit Kullanımı" },
        { Id: 970836, PropertyName: "value", Value: "Müşteri Borç Durumu" },
        { Id: 60018, PropertyName: "value", Value: "Toplam Borç" },
        { Id: 494344, PropertyName: "value", Value: "Ödenen Tutar" },
        { Id: 341165, PropertyName: "value", Value: "Kalan Borç" },
        { Id: 531691, PropertyName: "value", Value: "Son Ödeme Tarihi" },
        { Id: 658644, PropertyName: "value", Value: "Gecikmiş Taksit" },
        {
          Id: 246428,
          PropertyName: "value",
          Value: "2 adet gecikmiş taksit bulunmaktadır",
        },
        { Id: 914807, PropertyName: "value", Value: "İletişim Bilgileri" },
        { Id: 565544, PropertyName: "value", Value: "E-posta:" },
        { Id: 908234, PropertyName: "value", Value: "Cep Tel:" },
        { Id: 484091, PropertyName: "value", Value: "Adres Bilgileri" },
        { Id: 661202, PropertyName: "title", Value: "Title" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.customerdetail_989073_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetRetailCustomerDetail: [],
      GetRetailCustomerAdress: [],
      isComp923475Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "customerdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.CustomerDetailPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.CustomerDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "customerdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "customerdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.CustomerDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.CustomerDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  CustomerDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CurAccCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CurAccCode ??
          this.props.screenInputs.curacccode,
        "string"
      ),
      CurrAccCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CurAccCode ??
          this.props.screenInputs.curacccode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CustomerDetail/CustomerDetailPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetRetailCustomerDetail = result?.data.getRetailCustomerDetail;
    formVars.customerdetail_117780_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerName
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerName
        : null
    );
    formVars.customerdetail_922675_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].identityNum
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].identityNum
        : null
    );
    formVars.customerdetail_750527_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].creditLimit
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].creditLimit
        : null
    );
    formVars.customerdetail_668823_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].balance
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].balance
        : null
    );
    formVars.customerdetail_110181_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].remainingCreditLimit
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].remainingCreditLimit
        : null
    );
    formVars.customerdetail_48507_percent = ReactSystemFunctions.value(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].limitUsagePercent
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].limitUsagePercent
        : null
    );
    formVars.customerdetail_572476_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].installmentAmount
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].installmentAmount
        : null
    );
    formVars.customerdetail_512347_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].paymentAmount
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].paymentAmount
        : null
    );
    formVars.customerdetail_305124_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].remainingInstallment
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].remainingInstallment
        : null
    );
    formVars.customerdetail_512790_value = ReactSystemFunctions.value(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].lastPaymentDate
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].lastPaymentDate
        : null
    );
    formVars.customerdetail_136961_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerMail
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerMail
        : null
    );
    formVars.customerdetail_637657_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerPhone
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerPhone
        : null
    );
    stateVars.GetRetailCustomerAdress = result?.data.getRetailCustomerAdress;
    stateVars.isComp923475Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetRetailCustomerAdress !== undefined
            ? stateVars.GetRetailCustomerAdress?.length > 0
              ? stateVars.GetRetailCustomerAdress[0].address
              : null
            : this.state.GetRetailCustomerAdress?.length > 0
            ? this.state.GetRetailCustomerAdress[0].address
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CustomerDetailPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CustomerDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.customerdetail_117780_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerName
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerName
        : null
    );

    formVars.customerdetail_922675_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].identityNum
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].identityNum
        : null
    );

    formVars.customerdetail_750527_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].creditLimit
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].creditLimit
        : null
    );

    formVars.customerdetail_668823_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].balance
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].balance
        : null
    );

    formVars.customerdetail_110181_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].remainingCreditLimit
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].remainingCreditLimit
        : null
    );

    formVars.customerdetail_48507_percent = ReactSystemFunctions.value(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].limitUsagePercent
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].limitUsagePercent
        : null
    );

    formVars.customerdetail_572476_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].installmentAmount
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].installmentAmount
        : null
    );

    formVars.customerdetail_512347_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].paymentAmount
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].paymentAmount
        : null
    );

    formVars.customerdetail_305124_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].remainingInstallment
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].remainingInstallment
        : null
    );

    formVars.customerdetail_512790_value = ReactSystemFunctions.value(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].lastPaymentDate
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].lastPaymentDate
        : null
    );

    formVars.customerdetail_136961_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerMail
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerMail
        : null
    );

    formVars.customerdetail_637657_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerDetail !== undefined
        ? stateVars.GetRetailCustomerDetail?.length > 0
          ? stateVars.GetRetailCustomerDetail[0].customerPhone
          : null
        : this.state.GetRetailCustomerDetail?.length > 0
        ? this.state.GetRetailCustomerDetail[0].customerPhone
        : null
    );

    stateVars.isComp923475Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetRetailCustomerAdress !== undefined
            ? stateVars.GetRetailCustomerAdress?.length > 0
              ? stateVars.GetRetailCustomerAdress[0].address
              : null
            : this.state.GetRetailCustomerAdress?.length > 0
            ? this.state.GetRetailCustomerAdress[0].address
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.customerdetail_650800_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerAdress !== undefined
        ? stateVars.GetRetailCustomerAdress?.length > 0
          ? stateVars.GetRetailCustomerAdress[0].countryName
          : null
        : this.state.GetRetailCustomerAdress?.length > 0
        ? this.state.GetRetailCustomerAdress[0].countryName
        : null
    );

    formVars.customerdetail_689972_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerAdress !== undefined
        ? stateVars.GetRetailCustomerAdress?.length > 0
          ? stateVars.GetRetailCustomerAdress[0].cityName
          : null
        : this.state.GetRetailCustomerAdress?.length > 0
        ? this.state.GetRetailCustomerAdress[0].cityName
        : null
    );

    formVars.customerdetail_881114_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetRetailCustomerAdress !== undefined
        ? stateVars.GetRetailCustomerAdress?.length > 0
          ? stateVars.GetRetailCustomerAdress[0].address
          : null
        : this.state.GetRetailCustomerAdress?.length > 0
        ? this.state.GetRetailCustomerAdress[0].address
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.CustomerDetailPageInit();
    }
  }
}
